import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { reviewData } from "../../sample-data";

const initialState = {
  data: {},
  isLoading: true,
  error: "",
};

export const url = `https://jsonplaceholder.typicode.com/posts/1`;


export const fetchReviewOne = createAsyncThunk(
  "ReviewOne/fetchReviewOnezzzzzzz",
  async ({reviewId}, { rejectWithValue }) => {        
    await new Promise(resolve => setTimeout(resolve, 1000));
    return reviewData.find((review) => review.reviewId == reviewId) || {};
    // return reviewData;
    try {
      const response = await axios.get(url, {
        validateStatus: status => status >= 200 && status < 300,
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(`Error: ${err.message}`);
    }
  }
);

export const sliceReviewOne = createSlice({
  name: "ReviewOne",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchReviewOne.pending, (state) => {        
        state.isLoading = true;
        state.error = ""; // Reset error on pending state
      })
      .addCase(fetchReviewOne.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
        state.error = ""; // Reset error on successful fetch
      })
      .addCase(fetchReviewOne.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
        console.log(state.error);
      });
  },
});

export const selectReviewOneData = (state) => state.ReviewOne.data;
export const selectIsLoading = (state) => state.ReviewOne.isLoading;
export const selectError = (state) => state.ReviewOne.error;

// Access data directly from state using getter functions within your components
// for example:
// const data = useSelector(state => state.ReviewOne.data);
/*
const { data, isLoading, error } = useSelector(state => ({
  data: state.ReviewOne.data,
  isLoading: state.ReviewOne.isLoading,
  error: state.ReviewOne.error,
}));
*/
export default sliceReviewOne.reducer; // Export the reducer
